import { THEME_STORAGE_KEY } from 'config/theme'
import setTheme from 'util/setTheme'

const setThemeFromStorage = () => {
  const prefersLightMode = localStorage.getItem(THEME_STORAGE_KEY) === 'true'
  setTheme(prefersLightMode)
}

export default setThemeFromStorage
